__turbopack_context__.v({
  "item": "List-module-scss-module__-z5SuW__item",
  "list": "List-module-scss-module__-z5SuW__list",
});
